<div class="flex flex-col items-center justify-center gap-2 p-8">
  <span class="material-symbols-outlined text-primary" style="font-size: 48px">error</span>
  <h1 class="text-xl text-primary">Página não encontrada</h1>
</div>
